//import jwtDecode from "jwt-decode";

// const initialState = {
//     best_selling_products: [],
//     menu: [],
//     new_products: [],
//     sections: [],
//     special_offer_products: [],
//     sliders: []
// }
export const ui = (state = {}, action) => {
  switch (action.type) {
    case "UI": {
      return {
        category_parent: action.payload.category_parent,
        ages: action.payload.age,
        characters: action.payload.characters,
        best_selling_products: action.payload.best_selling_products,
        brands: action.payload.brands,
        contact_us: action.payload.contact_us,
        menu: action.payload.menu,
        new_products: action.payload.new_products,
        sections: action.payload.sections,
        special_offer_products: action.payload.special_offer_products,
          sliders: action.payload.sliders,
          articles: action.payload.articles,
          story: action.payload.story,
          diesel_generator: action.payload.diesel_generator,
          alternator: action.payload.alternator,
          control: action.payload.control,
          toy: action.payload.toy,
          sesame: action.payload.sesame,
          guns_and_fighting: action.payload.guns_and_fighting,
          notice: action.payload.notice,
          breaking_news: action.payload.breaking_news,
      };
    }
    default: {
      return state;
    }
  }
};
